import React, {useState} from "react";
import Icon from "../Icon";

import classes from "./styles.module.css";

function Tags({label, placeholder, suggestions, onChange, isDisabled}) {

    const excludeColumns = ["id"];

    const [tags, setTags] = useState([]);
    const [inputString, setInputString] = useState("");
    const [filteredSuggestions, setFilteredSuggestions] = useState(suggestions);

    const search = (string, tags) => {
        const lowercasedValue = string.toLowerCase().trim();

        let searchedData = [];
        let result = [];

        searchedData = suggestions.filter(item => {
            return Object.keys(item).some(key =>
                excludeColumns.includes(key) ? false : item[key].toString().toLowerCase().includes(lowercasedValue)
            );
        });

        result = searchedData.filter(function (el) {
            return tags.filter(function (tag) {
                return tag.id === el.id;
            }).length === 0
        });

        return result;
    }

    function handlerChangeString(val) {
        setInputString(val);
        setFilteredSuggestions(search(val, tags));
    }

    function handlerDelete(index, tag) {

        const arrTags = tags.filter((_, i) => i !== index);

        setTags(arrTags);
        onChange(arrTags);

        if (tag.hasOwnProperty("id"))
            setFilteredSuggestions([tag, ...filteredSuggestions]);
    }

    function handlerAddition(tag) {

        if (typeof tag === "string") {

            const lowercasedValue = tag.toLowerCase().trim();
            const hasTag = filteredSuggestions.filter(tag => {
                return tag.name.toLowerCase().trim() === lowercasedValue
            });

            if (hasTag.length) {

                const arrTags = [...tags, hasTag[0]];

                setTags(arrTags);
                onChange(arrTags);
                setFilteredSuggestions(search(inputString, arrTags));
            } else {

                const arrTags = [...tags, {name: tag}];

                setTags(arrTags);
                onChange(arrTags);
                setInputString("");
            }

        } else {

            const arrTags = [...tags, tag];

            setTags(arrTags);
            onChange(arrTags);
            setFilteredSuggestions(search(inputString, arrTags));
        }
    }


    return (
        <div className={classes.Wrap}>
            <label className={classes.Label}>{label}</label>

            <div className={classes.TagsBox}>
                {tags.map((tag, i) => {
                    return (
                        <span key={i} className={classes.Tag}>{tag.name}
                            <Icon onClick={() => handlerDelete(i, tag)} className={classes.CloseIcon} icon="close"
                                  size={'9px'}/>
                        </span>
                    )
                })}
            </div>

            <div className={classes.InputWrap}>
                <input
                    className={classes.Input}
                    type={"text"}
                    placeholder={placeholder}
                    value={inputString}
                    onChange={(e) => handlerChangeString(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" ? handlerAddition(e.target.value) : false}
                    disabled={isDisabled ? isDisabled : false}
                />

                {isDisabled &&
                    <Icon className={classes.LockIcon} icon={"lock"} size={"16px"}/>
                }

                {inputString.length > 2 &&
                    <button onClick={() => handlerAddition(inputString)} className={classes.Button}>Добавить</button>
                }

                {inputString.length > 2 && Boolean(filteredSuggestions.length) &&
                    <div className={classes.Suggestions}>
                        <ul>
                            {filteredSuggestions.map((el, i) => {
                                return <li onClick={() => handlerAddition(el)} key={i}>{el.name}</li>
                            })}
                        </ul>
                    </div>
                }
            </div>
        </div>
    )
}

export default Tags;


// WEBPACK FOOTER //
// ./src/Components/Utils/Tags/index.js